export default __webpack_public_path__ + "static/media/green_monster.04c13599.gif";